import { getUrl } from "./utils/url"

export default function clearFrontendCache() {
	return fetch(getUrl("/clear-cache", true)).catch(console.log)
}
